export default __webpack_public_path__ + "static/media/unknownChild.95ee544c.png";